
import { defineComponent, defineAsyncComponent, inject, Ref } from "vue";

import PrintButton from "@/components/NavBar/Print/PrintButton.vue";
import SaveButton from "@/components/NavBar/SaveButton.vue";
import SaveAndContinue from "@/components/NavBar/SaveAndContinue.vue";

const SaveTemplate = defineAsyncComponent(() =>
  import("@/components/Modals/User/SaveTemplate.vue" /* webpackChunkName: "saveTemplate" */)
);

import { UrlProperties } from "@/types";

export default defineComponent({
  name: "NavBar",
  components: {
    PrintButton,
    SaveButton,
    SaveAndContinue,
    SaveTemplate,
  },
  setup() {
    const urlProperties = inject("urlProperties") as Ref<UrlProperties>;

    return { urlProperties };
  },
});
